module.exports = __webpack_public_path__ + "static/media/pbnjSandwich.83d5f777.png";